export const navshow = () => {
    const leftnav = document.querySelector(".leftnav")
    const box = document.querySelector(".box")
    const headerbox = document.querySelector(".headerbox")
    const line1 = document.querySelector(".line1")
    const line2 = document.querySelector(".line2")
    const line3 = document.querySelector(".line3")
const masks = document.querySelector(".masks")
    
    if (leftnav.classList == "leftnav") {
        leftnav.setAttribute("class", "leftnav leftnavopen")
        headerbox.setAttribute("class", "headerbox headerboxanimation")
        box.setAttribute("class", "box boxtransform")
        document.documentElement.style.overflow = 'hidden'
        line1.setAttribute("class", "line line1 navclose2")
        line2.setAttribute("class", "line line2 navclose1")
        line3.setAttribute("class", "line line3 navclose3")
        masks.style.display="block"

        
            box.onclick=()=>{
                if(masks.style.display=="block"){
                navshow()
            }
            }
       
        
    } else {
        leftnav.setAttribute("class", "leftnav")
        box.setAttribute("class", "box")
        headerbox.setAttribute("class", "headerbox")
        document.documentElement.style.overflow = 'auto'
        line1.setAttribute("class", "line line1")
        line2.setAttribute("class", "line line2")
        line3.setAttribute("class", "line line3")
        masks.style.display="none"
    }


}